import styled from 'styled-components'
import React from "react"

export const ArticleImage = styled.img`
  width: 100%;
`;


export const ArticleH1= styled.h1`
  font-size: 120%;
  font-weight:700;
  margin-top:20px;
`;

export const ArticleIntro= styled.div`
  font-size: 90%;
  font-weight:500;
  margin-top:20px;
  font-style:italic;
`;

export const ArticleContent= styled.section`
  margin-left:auto;
  margin-right:auto;
  max-width:1200px;
  margin-top:20px;
  font-size:130%;
  padding-top:10px;
  padding-bottom:40px;
  line-height:2;
  h2{
    font-size:145%;
    font-weight:700;
    padding-top: 40px;
    padding-bottom:10px;
  }
`;

export const ArticleImageText = styled.div`
  width: 100%;
  font-size:90%;
`;

export const Aside = styled.aside`
  border: 5px solid #e3e3e3;
  margin-top:60px;
  font-size:110%;
  padding: 20px;
  padding-top:10px;
  padding-bottom:40px;
  
  line-height:2;
  h2{
    font-size:125%;
    font-weight:700;
    padding-top: 20px;
    padding-bottom:10px;
    opacity:0.7;
  }
`;

export const AsideTransparentBorder = styled.aside`
  border: 5px solid #ffffff;
  font-size:110%;
  padding: 20px;
  padding-top:10px;
  padding-bottom:40px;
  padding-top:0;
  line-height:2;

`;
